import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface User {
  id: number;
  email: string;
  first_name: string;
  last_name: string;
  status: string;
}

interface Company {
  id: number;
  name: string;
  role: string;
}

interface AuthState {
  user: User | null;
  company: Company | null;
  permissions: Record<string, unknown>;
  _isAuthenticated: boolean;

  setAuth: (user: User, company: Company, permissions: Record<string, unknown>) => void;
  logout: () => void;
  isAuthenticated: () => boolean;
}

function getCsrfToken(): string {
  const match = document.cookie.match(/csrf_access_token=([^;]+)/);
  return match ? match[1] : '';
}

export const useAuthStore = create<AuthState>()(
  persist(
    (set, get) => ({
      user: null,
      company: null,
      permissions: {},
      _isAuthenticated: false,

      setAuth: (user, company, permissions) =>
        set({ user, company, permissions, _isAuthenticated: true }),

      logout: () => {
        fetch('/api/auth/logout', {
          method: 'POST',
          credentials: 'include',
          headers: { 'X-CSRF-TOKEN': getCsrfToken() },
        }).catch(() => {});
        set({ user: null, company: null, permissions: {}, _isAuthenticated: false });
      },

      isAuthenticated: () => get()._isAuthenticated,
    }),
    { name: 'sideview-kiosk-auth' },
  ),
);
